import apiEndpoints from '../../../api';
import { clean, url, listParams, bodyOf, getReq, writeReq } from './vmsHttp';

export const getDeliveriesListReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_GET_DELIVERIES_LIST_API, listParams(d, {
        status: d?.status,
        flat_id: d?.flatId,
        delivery_type: d?.deliveryType,
    }), 'Failed to load deliveries');
};

export const getDeliveryDetailsReq = (action) =>
    getReq(url(apiEndpoints.SOCIETY_GET_DELIVERY_DETAILS_API, { id: action.data.id }),
        undefined, 'Failed to load delivery');

export const createDeliveryReq = (action) =>
    writeReq('post', apiEndpoints.SOCIETY_CREATE_DELIVERY_API, clean(bodyOf(action.data)),
        'Delivery logged', 'Failed to log delivery');

// flat_id, wing_id, visit_id and society_id are fixed at creation. `status` IS
// editable here — it is how a delivery reaches HELD_AT_GATE, REJECTED,
// RETURNED or CANCELLED, none of which the complete endpoint can set.
export const updateDeliveryReq = (action) =>
    writeReq('put', url(apiEndpoints.SOCIETY_UPDATE_DELIVERY_API, { id: action.data.id }),
        bodyOf(action.data, ['flat_id', 'wing_id', 'visit_id', 'society_id']),
        'Delivery updated', 'Failed to update delivery');

export const deleteDeliveryReq = (action) =>
    writeReq('delete', url(apiEndpoints.SOCIETY_DELETE_DELIVERY_API, { id: action.data.id }),
        undefined, 'Delivery removed', 'Failed to remove delivery');

// Accepts only DELIVERED_TO_RESIDENT (default) or DELIVERED_TO_GUARD. The API
// has no status guard, so completing an already-terminal delivery succeeds and
// overwrites received_at — the UI is what has to prevent that.
export const completeDeliveryReq = (action) =>
    writeReq('post', url(apiEndpoints.SOCIETY_COMPLETE_DELIVERY_API, { id: action.data.id }),
        clean({ status: action.data.status }), 'Delivery completed', 'Failed to complete delivery');
